import { render } from "./SmartViewDialogueBase.vue?vue&type=template&id=04b2f025"
import script from "./SmartViewDialogueBase.vue?vue&type=script&lang=js"
export * from "./SmartViewDialogueBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__